import * as NewsActionTypes from 'actiontypes/news';


import fetchNewsSuccess from './fetchNewsSuccess';

/**
 * Iniitial state
 * @type {Object}
 */
const initialState = {
  isFetching: false,
  newsItem: null,
  active: false,
};

/**
 * News Reducer
 * @param {Object} state
 * @param {[Object]} action
 */
export default function reducer(state = initialState, action) {
  const { payload = {} } = action;

  switch (action.type) {
    case NewsActionTypes.FETCH_NEWS_REQUESTED:
      return { ...state, isFetching: true, newsItem: null };
    case NewsActionTypes.FETCH_NEWS_FAILURE:
      return { ...state, isFetching: false, newsItem: null };

    case NewsActionTypes.FETCH_NEWS_SUCCESS:
      return fetchNewsSuccess(state, payload);

    case NewsActionTypes.DISMISS_NEWS_ITEM:
      return { ...state, active: false };

    default:
      return state;
  }
}